import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { HeroImage } from "../shared/hero-image";
import Breadcrumb from "./../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import stylesListicle from "./styles.m.css";
import Icon from "../../../../atoms/icon";
import ImageCaption from "../shared/elements/image-caption";
import ResponsiveImageWithFallback from "../../../../atoms/responsive-image-with-fallback";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import { generateImageSources } from "../../../../utils/utils";
import { humanizeDate } from "../../../../utils/time-format";
import { Link } from "@quintype/components";
import { fetchvuuklegetCommentCount } from "../../../../../api";
import { ScrollPercentage } from "react-scroll-percentage";

const ListicleStoryImageElement = ({ element }) => {
  return (
    <div className={`${stylesListicle["listicle-image"]}`}>
      <ResponsiveImageWithFallback
        className={stylesListicle["image-listicle"]}
        slug={element["image-s3-key"]}
        metadata={element["image-metadata"]}
        alt={element["image-caption"]}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [16, 9], screenWidthCoverage: 1 },
          { aspectRatio: [16, 9], screenWidthCoverage: 0.5 }
        )}
      />
      <ImageCaption element={element} />
    </div>
  );
};

ListicleStoryImageElement.propTypes = {
  element: {
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.string,
    "image-caption": PropTypes.string,
    "image-attribution": PropTypes.string
  }
};

function ListicleStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const cardsToBeNumbered = get(props, ["story", "cards"], []).filter(card => card["card-type"] !== "introduction")
    .length;
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyIndex = get(props, ["index"], 0);
  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;
  const cardLength = cards.length;
  const story = get(props, ["story"], () => null);
  const storyId = get(props, ["story", "id"], "");
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);

  const [showShare, setShowShare] = useState(false);

  const [commentsCount, setCommentsCount] = useState(null);
  const expandComments = get(props, ["expandComments"], () => null);
  const [Percentage, setPercentage] = useState(0);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(
    () => {
      GetStoryScrollPercentage(Percentage);
    },
    [Percentage]
  );

  const renderBullet = (card, index) => {
    if (card["card-type"] !== "introduction") {
      return (
        <div className={stylesListicle["bullet"]}>
          {props.story["bullet-type"] === "123" ? (
            <span className={stylesListicle["bullet-text"]}>{index + 1}</span>
          ) : props.story["bullet-type"] === "321" ? (
            <span className={stylesListicle["bullet-text"]}>{cardsToBeNumbered - (index + 1)}</span>
          ) : (
            <Icon type={"bullet-arrow"} className={stylesListicle["bullet-icon"]} />
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="page-content">
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} ${stylesListicle["story-body"]} js-story`}>
            <Breadcrumb subSection={section} config={props.config} />
            <ScrollPercentage>
              {({ percentage, ref }) => {
                const percentageRound = percentage.toFixed(2) * 100;
                if (percentageRound) {
                  setPercentage(percentageRound);
                }
                return (
                  <div ref={ref}>
                    {renderHeaderCard({ className: stylesListicle["listicle-header"] })}
                    <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>

                    <div className={styles["published-time-wrap"]}>
                      {story["first-published-at"] && (
                        <span className={styles["published"]}>
                          Published:
                          <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                            {humanizeDate(story["first-published-at"], "relative")}
                          </time>
                        </span>
                      )}
                      {story["last-published-at"] && (
                        <span className={styles["updated"]}>
                          Updated:
                          <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                            {humanizeDate(story["last-published-at"], "relative")}
                          </time>
                        </span>
                      )}
                    </div>

                    <div className={styles["hero-image-wrapper"]}>
                      <HeroImage
                        story={props.story}
                        className={styles["hero-image"]}
                        icon="listicle"
                        headline="Listicle"
                      />
                    </div>
                    <div className={styles["audio-share-wrapper"]}>
                      <div className={styles["audio-comments-share"]}>
                        <div>
                          <Link
                            href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles["box-div"]}
                          >
                            <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                            <span className={styles["channel-txt"]}>Join Our Channel</span>
                          </Link>
                          {/* <Link
                    href="https://bit.ly/3J0OoJc"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                    style={{ padding: "0" }}
                  >
                    <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                  </Link> */}
                        </div>
                        <div className={styles["box-div"]} onClick={scrollToComments}>
                          <Icon type="comment" />
                          <span className={styles["channel-txt"]}>{commentsCount && commentsCount[storyId]}</span>
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                        </div>
                        <div
                          className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""}`}
                          onClick={handleShareClick}
                        >
                          <Icon type="socialshare" />
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                        </div>
                      </div>

                      <div className={styles["social-share-wrapper"]}>
                        {showShare && !readMore && renderSocialMedia("", false)}
                      </div>
                    </div>

                    {cards &&
                      cards.map((card, index) => {
                        return (
                          <div key={card.id}>
                            <VikatanResponsiveContainer
                              placement={"text-story"}
                              story={props.story}
                              className="ad_300_250"
                              adtype={parseInt(index + 1)}
                              storyId={props.story.id}
                            />
                            <div className="listical-story">
                              {renderBullet(card, index)}
                              <StoryCard
                                card={card}
                                story={props.story}
                                showCard={readMore}
                                cardLength={cardLength}
                                index={index}
                                storyIndex={storyIndex}
                                renderRelatedArticle={renderRelatedArticle}
                                config={props.config}
                              />
                            </div>
                            {index === 1 && (
                              <div>
                                <StoryMidPromotion story={props.story} />
                              </div>
                            )}
                            <br />
                          </div>
                        );
                      })}
                  </div>
                );
              }}
            </ScrollPercentage>
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>

            <div id="we-story-end" />
          </article>
          {renderFooter(readMore)}
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}

ListicleStory.propTypes = {
  story: PropTypes.shape(),
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { ListicleStory, ListicleStoryImageElement };
